export default "__VITE_PUBLIC_ASSET__f86ac97c__"